import Swal from "sweetalert2";

export function onSuccess(title = "Your work has been saved") {
  Swal.fire({
    icon: "success",
    title,
    showConfirmButton: false,
    timer: 1500
  });
}

export function onError(title = "Your work not saved") {
  Swal.fire({
    icon: "error",
    title
  });
}

export async function onConfirm(confirmButtonText = "Yes, delete it!") {
  const isConfirmed = await Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText
  });
  return isConfirmed;
}

export async function onLoading() {
  Swal.showLoading();
}
